<template>
  <div class="mb-3">
    <label :for="question.id" class="form-label">{{ question.label }}</label>
    
    <input
      v-if="question.type === 'text'"
      :id="question.id"
      type="text"
      class="form-control"
      v-model="localValue"
      required
    />
    <template v-else-if="question.type === 'calendar'">
      <!-- <VCalendar  /> -->
       <br/>
       <input type="hidden" class="form-control" 
       :name="question.id" 
       :id="question.id" 
       v-model="localValue"/>
      <VDatePicker v-model="localValue" :masks="masks"/>
    </template>
    <div v-else-if="question.type === 'radio'" class="form-check-container">
      <div v-for="option in question.options" :key="option" class="form-check">
        <input
          class="form-check-input"
          type="radio"
          :id="`${question.id}-${option}`"
          :name="question.id"
          :value="option"
          v-model="localValue"
        />
        <label class="form-check-label" :for="`${question.id}-${option}`">{{ option }}</label>
      </div>
    </div>
    <!-- Multi-choice checkbox input -->
    <div v-else-if="question.type === 'checkbox'" class="form-check-container">
      <div v-for="option in question.options" :key="option" class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          :id="`${question.id}-${option}`"
          :value="option"
          v-model="localValue"
        />
        <label class="form-check-label" :for="`${question.id}-${option}`">{{ option }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['question', 'value'],
  data() {
    return {
    masks:{
      localValue: 'YYYY-MM-DD'}
    }
  },
  computed: {
    localValue: {
      get() {
        //console.log(this.value);
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>
